import { Assessment } from '../../types/assessments/assessment'
import { FieldMapValue } from '../../types/utils/common'

export const getMidwifeId = (data?: FieldMapValue) => data?.delivery?.midwifeId

export const getPregnancyMidwifeId = (assessment?: Assessment | null): string | null => {
  const correctionsVal = getMidwifeId(assessment?.corrections)
  if (correctionsVal && typeof correctionsVal === 'string') return correctionsVal
  const dataVal = getMidwifeId(assessment?.data)
  if (dataVal && typeof dataVal === 'string') return dataVal
  return assessment?.midwifeId ?? null
}
